import { computed, nextTick, ref } from 'vue';

export const PROGRESS = {
	DATA: 0,
	CONFIRMATION: 1,
	DONE: 2
};
const currentStep = ref(0);
export const jumpToTop = () => nextTick(() => document.getElementById('weka-top').scrollIntoView());
const next = () => {
	currentStep.value += 1;
	jumpToTop();
};
const back = () => {
	currentStep.value = PROGRESS.DATA;
	jumpToTop();
};
const steps = computed(() => [
	{
		text: 'Adatok',
		editUrl: null,
		current: currentStep.value === PROGRESS.DATA,
		done: currentStep.value > PROGRESS.DATA
	},
	{
		text: 'Megerősítés',
		editUrl: null,
		current: currentStep.value === PROGRESS.CONFIRMATION,
		done: currentStep.value > PROGRESS.CONFIRMATION
	},
	{
		text: 'Befejezés',
		editUrl: null,
		current: currentStep.value === PROGRESS.DONE,
		done: currentStep.value === PROGRESS.DONE
	}
]);
export const useProgress = () => {
	const isData = computed(() => currentStep.value === PROGRESS.DATA);
	const isConfirmation = computed(() => currentStep.value === PROGRESS.CONFIRMATION);
	const isDone = computed(() => currentStep.value === PROGRESS.DONE);
	return { currentStep, next, back, steps, isData, isConfirmation, isDone };
};
